import { render, staticRenderFns } from "./alert-troppa-iva.vue?vue&type=template&id=5ce0bea8&lang=html&"
import script from "./alert-troppa-iva.vue?vue&type=script&lang=js&"
export * from "./alert-troppa-iva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports